<mat-sidenav-container>
  <mat-sidenav #sidenav [mode]="'over'">
    <app-sidenav-content></app-sidenav-content>
  </mat-sidenav>

  <mat-sidenav-content>
    <app-header
      (isHandsetPortraitStatus)="isHandsetPortraitStatus($event)"
      (openSideNav)="sidenav.toggle()"
    ></app-header>
    <div class="sggs-dashboard-content">
      <div class="small-carousel carousel-wrapper" style="background-color: #ffffff !important;" [class.is-mobile]="isHandsetPortrait">
        <div class="title-banner-wrapper-new {{bannerClass}}">
          <h1 class="bani-title-new">
            Our Team
          </h1>
          <p class="bani-title-detail-new">
            The Guru Granth Sahib Project is a global initiative dedicated to making the infinite wisdom of the Guru Granth Sahib accessible to English and Panjabi speakers worldwide.
          </p>
        </div>
        <div><img style="min-height: 70px;" src="../../../assets/project/images/Border--Zigzag-bottom--TGGSP-01.svg" alt="Zigzag Bottom Border Image"></div>
      </div>
      
      <div class="padded-content-wrapper" [class.is-mobile]="isHandsetPortrait">
        <div [class.is-mobile]="isHandsetPortrait" class="heading-para-section-new">
          <h2 class="static-content-heading-wrapper-new">
            {{ activeLanguageTranslations?.strategicLabel }}
          </h2>
          <div class="static-content-paragraph-new">
            {{ activeLanguageTranslations?.coreTeamDetail }}
          </div>
        </div>
        <div class="static-content-paragraph">
          <div [class.is-mobile]="isHandsetPortrait" class="sggs-team-members-wrapper-grid">
            <ng-container *ngFor="let member of teamDetails">
              <div *ngIf="member.Category === 'Strategy'" [class.is-mobile]="isHandsetPortrait"  class="sggs-team-member-wrapper-new">
                <div [class.is-mobile]="isHandsetPortrait" class="sggs-team-member-content-new">
                  <div class="team-member-heading-wrapper-new">
                    <div *ngIf="!member.UserImage" class="team-member-heading-new dummy">
                      <span class="img-name-new" [innerHTML]="getFirstCharofStr(member.FirstName,member.LastName)"></span>
                      <img alt="Member Placeholder Image" src="/assets/images/teamMemberPlaceholder.png" />
                    </div>
                    <div *ngIf="member.UserImage" class="team-member-heading-new">
                      <img alt="{{member.FirstName}} Image" [src]="member.UserImage" />
                    </div>
                  </div>
                  <div [class.is-mobile]="isHandsetPortrait" class="team-member-content-wrapper-new">
                    <!-- <div [class.is-mobile]="isHandsetPortrait" class="team-member-info-wrapper-new"> -->
                      <div class="team-member-name-new">{{member.FirstName}} {{member.LastName}}</div>
                      <div class="team-member-location-new">{{member.Location}}</div>
                    <!-- </div> -->
    
                    <!-- <div class="team-member-qualifications-wrapper-new"> -->
                      <div class="team-member-designation-new">
                        {{member.ProjectRole}}
                      </div>
                      <div class="team-member-old-designation-new">
                         {{member.Title}}
                      </div>
                      <span style="width: 100%; border-top: 1px solid #e5e5e5"></span>
                      <div class="team-member-qualifications-new"> {{member.Background}} </div>
                    <!-- </div> -->
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
        </div>

        <hr class="divider"/>

        <div [class.is-mobile]="isHandsetPortrait" class="heading-para-section-new">
          <div class="static-content-heading-wrapper-new">
            {{ activeLanguageTranslations?.coreTeam }}
          </div>
          <div class="static-content-paragraph-new">
            {{ activeLanguageTranslations?.coreTeamDetail }}
          </div>
        </div>
        <div class="static-content-paragraph">
          <div [class.is-mobile]="isHandsetPortrait" class="sggs-team-members-wrapper-grid">
            <ng-container *ngFor="let member of teamDetails">
            <div *ngIf="member.Category === 'Core'"  [class.is-mobile]="isHandsetPortrait"  class="sggs-team-member-wrapper-new">
              <div [class.is-mobile]="isHandsetPortrait" class="sggs-team-member-content-new">
                <div class="team-member-heading-wrapper-new">
                  <div *ngIf="!member.UserImage" class="team-member-heading-new dummy">
                    <span class="img-name-new" [innerHTML]="getFirstCharofStr(member.FirstName,member.LastName)"></span>
                    <img alt="Member Placeholder Image" src="/assets/images/teamMemberPlaceholder.png" />
                  </div>
                  <div *ngIf="member.UserImage" class="team-member-heading-new">
                    <img alt="{{member.FirstName}} Image" [src]="member.UserImage" />
                  </div>
                </div>
                <div [class.is-mobile]="isHandsetPortrait" class="team-member-content-wrapper-new">
                  <!-- <div [class.is-mobile]="isHandsetPortrait" class="team-member-info-wrapper-new"> -->
                    <div class="team-member-name-new">{{member.FirstName}} {{member.LastName}}</div>
                    <div class="team-member-location-new">{{member.Location}}</div>
                  <!-- </div> -->
  
                  <!-- <div [class.is-mobile]="isHandsetPortrait" class="team-member-qualifications-wrapper-new"> -->
                    <div class="team-member-designation-new">
                      {{member.ProjectRole}}
                    </div>
                    <span class="lineForMobileVew" style="width: 100%; border-top: 1px solid #e5e5e5"></span>
                    <div class="team-member-old-designation-new">
                       {{member.Title}}
                    </div>
                    <span [class.is-mobile]="isHandsetPortrait" class="lineForNormaleVew" style="width: 100%; border-top: 1px solid #e5e5e5"></span>
                    <div [class.is-mobile]="isHandsetPortrait" class="team-member-qualifications-new-core-team"> {{member.Background}} </div>
                  <!-- </div> -->
                </div>
              </div>
            </div>
            </ng-container>
          </div>
        </div>

        <!-- <div class="static-content-heading-wrapper-new">
          {{ activeLanguageTranslations?.strategicLabel }}
        </div>



        <div class="static-content-heading-wrapper-new">
          {{ activeLanguageTranslations?.projectTeamLabel }}
        </div> -->

        <div [class.is-mobile]="isHandsetPortrait" class="join-us-section">
          <div [class.is-mobile]="isHandsetPortrait" class="join-us-div">
            <div class="join-us-text">
              <h3>Join us in making the infinite wisdom of the Guru Granth Sahib more accessible to the world</h3>
              <p>Whether you are a researcher, translator, designer, or developer, your
                skills can help shape this meaningful project. Be part of a passionate
                team dedicated to preserving and sharing these teachings-together,
                we can make a lasting impact.</p>
              <p><a href="#">View Career Openings</a></p>
            </div>
            <div  class="earth-image-div">
                <img src="assets/project/images/Earth.png" sizes="(max-width: 479px) 250px, (max-width: 767px) 400px, 500px" srcset="assets/project/images/Earth-p-500.png 500w, assets/project/images/Earth-p-800.png 800w, assets/project/images/Earth.png 893w" alt="Earth Image">
            </div>
          </div>
        </div>

        
      </div>
      <app-footer [isHandsetPortrait]="isHandsetPortrait"></app-footer>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
